import { jwtDecode, JwtPayload } from 'jwt-decode';
import Helpers from './helper';
import { CustomJwtPayload } from './jwtDecodePayload';

export class TokenHelper {
    public static isAuthorized() {
        return localStorage.getItem('token');
    }

    public static isTokenValid(): boolean {
        const token = localStorage.getItem('token');
        if (!token) return false;
        try {
            const decoded = jwtDecode<JwtPayload>(token);
            if (!decoded.exp) return false;
            if (decoded.exp * 1000 > Date.now()) return true;
            return !!localStorage.getItem('refreshToken');
        } catch {
            return false;
        }
    }

    public static clearLocalStorage = (includeSummary: boolean) => {
        Helpers.clearLocalStorageExceptRequiredParameters(includeSummary);
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('expiresIn');
        localStorage.removeItem('email');
        localStorage.removeItem('name');
        if (includeSummary) localStorage.removeItem('loggedInUserSummary');
        localStorage.removeItem('currentPracticeId');
    };

    public static getTokenLifeTimeInMinutes = () => {
        const expiresInSeconds = localStorage.getItem('expiresIn');
        const expiresInMinutes = Math.floor(Number(expiresInSeconds) / 60);
        return expiresInMinutes;
    };

    public static setTokenToLocalStorage = (authenticationResult: any) => {
        if (!authenticationResult) return;
        localStorage.setItem('token', authenticationResult.idToken);
        localStorage.setItem('expiresIn', authenticationResult.expiresIn);
        localStorage.setItem('accessToken', authenticationResult.accessToken);
        if (authenticationResult.newDeviceMetadata) {
            localStorage.setItem(
                'deviceKey',
                authenticationResult.newDeviceMetadata.deviceKey
            );
            localStorage.setItem(
                'deviceGroupKey',
                authenticationResult.newDeviceMetadata.deviceGroupKey
            );
        }
    };

    public static getUserIdFromToken = () => {
        let token = localStorage.getItem('token');
        if (token) {
            let decodedToken = jwtDecode<CustomJwtPayload>(token);
            if (decodedToken) {
                if (decodedToken['custom:id']) {
                    return Number(decodedToken['custom:id']);
                }
            }
        }
        return null;
    };
}
